import { render, staticRenderFns } from "./RecoveryAtIdA.html?vue&type=template&id=6655e978&scoped=true&"
import script from "./RecoveryAtIdA.vue?vue&type=script&lang=js&"
export * from "./RecoveryAtIdA.vue?vue&type=script&lang=js&"
import style0 from "./RecoveryAtIdA.scss?vue&type=style&index=0&id=6655e978&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6655e978",
  null
  
)

export default component.exports